import { Outlet, useLocation, useNavigate } from "react-router-dom";
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from "../../custom-components/QMentisBreadCrumb";
import DownloadIcon from "@mui/icons-material/Download";
import { Typography } from "@mui/material";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestCaseUI from "../../output-components/test-automation/TestCaseImported";
import Feature from "../../output-components/test-automation/FeatureFilesCreated";
import InputForm from "../../output-components/test-automation/PageSource";
import PageClass from "../../output-components/test-automation/PageClass";
import Locators from "../../output-components/test-automation/Locators";
import RobotFile from "./RobotFile";
import StepDefinition from "../../output-components/test-automation/StepDefinition";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { featureFiles, robotFilesService, keyWordDesign, midLevelKeyWordDesign } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import SelectFrameWork from "../input-pages/SelectFrameWork";
import TestEnvironmentForm from "../../output-components/test-automation/TestEnvironment";
import BusinessKeywordDesign from "../../output-components/test-automation/BusinessKeywordDesign";
import MidLevelKeywords from "../../output-components/test-automation/MidLevelKeywords";
import KeywordDesign from "../../output-components/test-automation/KeywordDesign";
import UploadBox from "../input-pages/UploadBox";
import CommonDownload from "../../custom-components/CommonDownload";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";


export const TestCaseFlowDataContext = createContext(null);

const RobotNewProjectOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [testCase, setTestCase] = useState({});
  const [projectType, setProjectType] = useState("");
  const [testEnvironment, setTestEnviorment] = useState({});
  const [keywordDesign, setKeywordDesign] = useState("");
  const [midLevelKeywords, setMidLevelKeywords] = useState({});
  const [uploadBox, setUploadBox] = useState({});
  const [showInputForm, setShowInputForm] = useState(false);
  const [keywordoutputFS, setkeywordoutputFS] = useState("");

  const [featureFile, setFeatureFile] = useState("");
  const [pageSource, setPageSource] = useState("");
  const [locator, setLocator] = useState('');
  const [pageClass, setPageClass] = useState("");
  const [robotFile, setRobotFile] = useState("");
  const [RobotFrameworkGenerated, setRobotFrameworkGenerated] = useState({});
  const [responseError, setResponseError] = useState(null);
  const { setLoadingState } = useContext(LoadingModalContext);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [framework, setframework] = useState("");
  const [keywordBreadCum, setkeywordBreadCum] = useState(false);
  const [keywordCompletedBreadCrum, setkeywordCompletedBreadCrum] = useState(false);


  const [isFrameworkConfirmed, setIsFrameworkConfirmed] = useState(false);
  const handleFrameworkConfirm = () => {
    setIsFrameworkConfirmed(true);
  };

  useEffect(() => {
    console.log(location.state, "output page");

    setProjectType(location.state?.projectType || "");
    setTestCase(location.state?.testCaseData || {});
    setTestEnviorment(location.state?.testenvironmentdata || {});
    setKeywordDesign(location.state?.keywordDesignData || "");
    setMidLevelKeywords(location.state?.midLevelKeywordsData || {});
    setUploadBox(location.state?.uploadBoxData || {});
    setPageSource(location.state?.pageSource || "");
    setLocator(location.state?.generatedLocators || {});
    setPageClass(location.state?.generatedPageclassData || "");
    setRobotFile(location.state?.generatedRobotFileData || "");
    setframework(location.state?.framework || "");
    setkeywordBreadCum(location.state?.keywordBreadCum || false);
    setkeywordCompletedBreadCrum(location.state?.keywordCompleted || false);
  }, [
    location.state?.projectType,
    location.state?.testCaseData,
    location.state?.testenvironmentdata,
    location.state?.featureFileData,
    location.state?.keywordDesignData,
    location.state?.uploadBoxData,
    location.state?.midLevelKeywordsData,
    location.state?.pageSource,
    location.state?.generatedLocators,
    location.state?.generatedPageclassData,
    location.state?.generatedRobotFileData,
    location.state?.framework,
    location.state?.keywordBreadCum,
    location.state?.keywordCompleted
  ]);

  const breadCrumbs = [

    {
      title: "Set Test Environment",
      status: Object.entries(testEnvironment).length !== 0 || confirmed ? "Completed" : "In Progress",
    },

    {
      title: "Test Case Details",
      status: Object.entries(testCase).length > 0
        ? "Completed"
        : Object.entries(testEnvironment).length !== 0 && Object.entries(testCase).length === 0
          ? "In Progress"
          : "Not Started",
    },

    {
      title: "High-Level Keywords",
      status:
        Object.keys(keywordDesign).length > 0 && keywordCompletedBreadCrum
          ? "Completed"
          : Object.entries(keywordDesign).length > 0
            ? "In Progress"
            : "Not Started",
    },

    {
      title: "Mid-Level Keywords",
      status:
        Object.keys(midLevelKeywords).length > 0
          ? "Completed" : "Not Started"
    },
    {
      title: "Introduce SUT",
      status:
        !!pageSource && pageSource !== ""
          ? "Completed"
          : "Not Started",
    },
    {
      title: "Generate Locators",
      status:
        Object.keys(locator).length > 0
          ? "Completed"
          : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },

    {
      title: "Generate Robot File",
      status:
        !!robotFile && robotFile !== ""
          ? "Completed"
          : "Not Started",
    },
  ];


  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleKeywordDesign = async () => {
    let progressHandler;
    progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 18000 });

    try {

      progressHandler.start("Generating High-level Keywords");

      const keywordDesignOutput = await keyWordDesign({ TestCase: testCase });
      const keywordCompleted = true;

      setKeywordDesign(keywordDesignOutput.data);

      navigate(`/dashboard/test-automation/robot-framework/${projectType}`, {
        state: {
          ...location.state,
          framework: framework,
          keywordCompleted,
          keywordDesignData: keywordDesignOutput.data,
        },
      });

      await progressHandler.finishAndClose();
    } catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred while processing the keyword design. Please try again.";
      setPopupMessage(errorMsg);
      alert(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
    } finally {
      progressHandler.stop();
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const generateMidLevelKeywords = async () => {

    let progressHandler;
    progressHandler = handleProgressBar({
      setLoadingState,
      totalDurationMs: 18000
    });
    try {
      progressHandler.start("Generating Mid-level Keywords");
      const midLevelKeyWordOutput = await midLevelKeyWordDesign({ TestCase: testCase, BusinessKeywords: keywordDesign })
      setMidLevelKeywords(midLevelKeyWordOutput.data)
      await progressHandler.finishAndClose();
      navigate(`/dashboard/test-automation/robot-framework/${projectType}`, {
        state: {
          ...location.state,
          framework: framework,
          midLevelKeywordsData: midLevelKeyWordOutput.data,
        }
      });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred while processing the mid level design. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      progressHandler.stop();
      setLoadingState({ open: false, message: "", progress: null });

    }
  }
  const handeNextClick = (e) => {
    e.preventDefault();
    setkeywordBreadCum(true);
    setShowInputForm(true);
    navigate(`/dashboard/test-automation/robot-framework/${projectType}`, {
      state: {
        ...location.state,
        projectType: projectType,
        framework: framework,
        showInputForm: true
      },
    });
  };
console.log(testEnvironment)
  const handleRobotFiles = async () => {
    let progressHandler;
    progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 18000 });

    try {
      progressHandler.start("Generating Robot file")
      const generatedRobotFilesResponse = await robotFilesService({
        testCase,
        midLevelKeywords: midLevelKeywords,
        testEnvironmentData: testEnvironment,
        locators: locator,
      });
      const generatedRobotFiles = generatedRobotFilesResponse.data;
      navigate(location.pathname, { state: { ...location.state, generatedRobotFileData: generatedRobotFiles, framework: framework }, replace: true })
      setRobotFile(generatedRobotFiles);
      await progressHandler.finishAndClose();
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
    }
    finally {
      progressHandler.stop();
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const handlePageSource = () => {
    navigate(location.pathname, {
      state: { ...location.state, pageSource: "", framework: framework },
      replace: true,
    });
  };

  const testcaseNextButton = {
    label: "High-Level Keywords",
    onClick: handleKeywordDesign,
    startIcon: <GenerateButton />,
    variant: "contained",

  };
  const keywordNextButton = {
    label: "Mid-Level Keywords",
    variant: "contained",
    startIcon: <GenerateButton />,
    onClick: generateMidLevelKeywords,
    // sx: { float: "right" },
    //sx: { ml: 40 },
  };
  const midlevelNextButton = {
    label: "Introduce SUT",
    variant: "contained",
    startIcon: <GenerateButton />,
    onClick: handeNextClick
  };

  const locatorsNextButton = {
    label: "Generate Robot File",
    onClick: handleRobotFiles,

    variant: "contained",
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  };

  const robotFrameworkDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none", float: "left" },

  };


  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      // console.log(typeof value);
      // console.log(value)
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };
  const handleCloseDownload = () => {
    setDownloadOpen(false);
  }
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
        zIndex: 999999999
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%", // Adjust width when sidebar expands
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
            padding: "0 8px",
            transition: "width 0.3s ease-in-out", // Smooth transition effect
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{
              height: "auto",
              minHeight: "68px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              wordBreak: "break-word",
              textOverflow: "ellipsis",
              flexShrink: 1,
              width: "100%",
              maxWidth: "100%",
              transition: "max-width 0.3s ease-in-out", // Adjust when sidebar expands
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />
            </Box>


            {/* Robot Framework Components */}

            {/* 1.Test Environment */}
            {Object.entries(testEnvironment).length === 0 && (
              <TestEnvironmentForm
                testEnvironmentData={testEnvironment}
                setTestEnviorment={setTestEnviorment}
                //keywordDesignData={keywordDesign}
                framework={location.state?.framework}
                projectType={location.state?.projectType}
                confirmed={confirmed}
                setConfirmed={setConfirmed}
              />
            )}

            {/* 1.Test Case Upload */}
            {confirmed && (
              <UploadBox
                uploadBoxData={uploadBox}
                setUploadBox={setUploadBox}
                setTestCase={setTestCase}
                //robotFrameworkDownloadButton={robotFrameworkDownloadButton}
                framework={location.state?.framework}
                projectType={projectType}
              />
            )}

            {/* 3.Test Case UI */}
            {Object.entries(testCase).length > 0 && (
              <TestCaseUI
                testCase={testCase}
                testCaseData={testCase}
                setTestCase={setTestCase}
                testcaseNextButton={testcaseNextButton}
                robotFrameworkDownloadButton={robotFrameworkDownloadButton}
                framework={location.state?.framework}
                projectType={projectType}
              />
            )}

            {/* 4.Keyword Design */}
            {keywordDesign && keywordDesign.trim() !== "" && (
              <KeywordDesign
                keywordDesignData={keywordDesign}
                setKeywordDesign={setKeywordDesign}
                framework={location.state?.framework}
                keywordNextButton={keywordNextButton}
                //keyWordDesignCodeEditorData={midLevelKeywords.keyWordCodeEditorData}
                projectType={location.state?.projectType}
              />
            )}

            {Object.entries(midLevelKeywords).length !== 0 && midLevelKeywords && (
              <MidLevelKeywords
                midLevelKeywordsData={midLevelKeywords}
                setMidLevelKeywords={setMidLevelKeywords}
                keywordDesignData={keywordDesign}  //Pass keywordDesign data here
                //setUploadBox={setUploadBox}
                midlevelNextButton={midlevelNextButton}
                framework={location.state?.framework}
                projectType={projectType}
                keywordBreadCum={keywordBreadCum}
                setkeywordBreadCum={setkeywordBreadCum}
                setPageSource={setPageSource}
              />
            )}

            {showInputForm && (
              <InputForm
                setPageSource={setPageSource}
                projectType={projectType}
                framework={location.state?.framework}
              // Pass the necessary props to InputForm
              />
            )}

            {Object.entries(locator).length > 0 && (
              <Locators
                locator={locator}
                setLocator={setLocator}
                locatorsNextButton={locatorsNextButton}
                projectType={projectType}
                framework={location.state?.framework}
              />
            )}
            {!!robotFile && robotFile !== "" && (
              <RobotFile
                robotFile={robotFile}
                setRobotFile={setRobotFile}
                testCases={testCase}
                locator={locator}
                setLocator={setLocator}
                midLevelKeywordsData={midLevelKeywords}
                keywordDesignData={keywordDesign}
                framework={location.state.framework}
                projectType={location.state?.projectType}
                testEnvironmentData={testEnvironment}
              />
            )}
          </Box>
        </Box>
        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Container
          sx={{
            // paddingTop: "50px", // Adjust this value based on the height of the breadcrumb
            width: "100%",
          }}
        >
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>

      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
    </Box>
  );
};

export default RobotNewProjectOutputPage;
